import * as Yup from 'yup';

const formValidationSchema = Yup.object().shape({
  dbaName: Yup.string(),
  address: Yup.object().shape({
    address_ln_1: Yup.string(),
    address_ln_2: Yup.string(),
    city: Yup.string(),
    state: Yup.string(),
    zip: Yup.string()
  }),
  stickyNotesAlert: Yup.boolean(),
  surchargeEnabled: Yup.boolean(),
  surchargeAmount: Yup.number().min(0).max(400),
  batchTime: Yup.string()
});

export default formValidationSchema;
